module.exports = __webpack_public_path__ + "static/media/runbike.54219e50.gif";